import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'brn-form-option',
  templateUrl: './form-option.component.html',
  styleUrls: ['./form-option.component.scss'],
})
export class FormOptionComponent {
  @Input()
  optionLabel!: any;
  @Input()
  optionValue!: any;
  @Input()
  value!: any;
  @Input()
  option!: any;
  @Output() selectEvent = new EventEmitter<any>();

  get label(): any {
    if (this.optionLabel) {
      return this.option[this.optionLabel];
    }
    return this.option;
  }
  get selected(): any {
    if (this.optionLabel && this.value && !this.optionValue) {
      return this.label === this.value[this.optionLabel];
    } else if (this.optionValue) {
      return this.option[this.optionValue] === this.value;
    }
    return this.option === this.value;
  }

  select(): void {
    this.selectEvent.emit(this.option);
  }
}
